import { Stack, Typography } from '@mui/material';

export const CertificationDataClient = ({ client, formValues }) => {
    //client trae de bbdd: {name, tel, email, fax, movil, address, cif}
    //formValues trae de formulario: {characteristics, status, client, contact, date, dateCall, iva, paymentMhetod, tel, inputFields: [{id, type, amount, days}], address }

    return (
        <Stack>
            <Typography variant='caption'><b>Cliente:</b> {client.name}</Typography>
            <Typography variant='caption'><b>Obra:</b> {formValues.address || formValues.addressWork}</Typography>
            <Typography variant='caption'><b>Dirección empresa:</b> {client.address}</Typography>
            <Typography variant='caption'><b>Att. D.:</b> {formValues.contact}</Typography>
            {
                statusEstimate.includes(formValues.status) &&
                <Typography variant='caption'><b>Oferta nº:</b> {formValues.billNumber}</Typography>
            }
            {/* {
                !statusEstimate.includes(formValues.status)
                && <Typography variant='caption'><b>Detalles:</b> {formValues.characteristics}</Typography>
            } */}
        </Stack>
    )
}

const statusEstimate = ['Provisional', 'Definitivo', 'Aceptado'];